import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {

  productDetails$: Observable<any>;

  constructor(private http: HttpClient, private occService:OccEndpointsService,private currentProdService:CurrentProductService) { }

  getProdDetails(){
    this.productDetails$=this.currentProdService.getProduct();
  }
  getProductDetails(productCode) {
    const productCodee = productCode.replace("/","@");
   return this.http.get(this.occService.buildUrl(`products/${productCodee}`)).pipe(
      catchError(error => {
        return of(null);
      })
    );
  }
}
